import React, { useState } from 'react';
import {
    Box,
    Button,
    IconButton,
    Menu,
    MenuItem,
    Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface ICustomVerticalDropdownProps {
    label?: string;
    items: {
        component: React.ReactNode;
        callback?: () => void;
        color?: 'primary' | 'error';
        disabled?: boolean;
    }[];
}

export function CVerticalDropdown({
    items,
    label,
}: ICustomVerticalDropdownProps) {
    const [dropdownAnchor, setDropdownAnchor] = useState<null | HTMLElement>(
        null,
    );

    function handleCloseDropdown() {
        setDropdownAnchor(null);
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {label ? (
                <Button
                    variant={'outlined'}
                    size={'small'}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(e) => setDropdownAnchor(e.currentTarget)}
                >
                    {label}
                </Button>
            ) : (
                <IconButton
                    color={'primary'}
                    size={'small'}
                    sx={{
                        bgcolor: 'primary.main',
                        color: 'primary.contrastText',
                        borderRadius: '50%',
                        '&:hover': { bgcolor: 'primary.dark' },
                    }}
                    onClick={(e) => {
                        setDropdownAnchor(e.currentTarget);
                    }}
                >
                    <MoreVertIcon />
                </IconButton>
            )}
            <Menu
                anchorEl={dropdownAnchor}
                open={Boolean(dropdownAnchor)}
                onClose={handleCloseDropdown}
                variant={'selectedMenu'}
                onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                        e.stopPropagation();
                    }
                }}
            >
                {items.map(
                    (
                        { color, callback, component, disabled = false },
                        index,
                    ) => {
                        return (
                            <MenuItem
                                autoFocus={false}
                                disableRipple={!callback}
                                disableTouchRipple={!callback}
                                color={color}
                                key={index}
                                disabled={disabled}
                                sx={{
                                    cursor: !!callback ? 'pointer' : 'default',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key !== 'Escape') {
                                        e.stopPropagation();
                                    }
                                }}
                            >
                                {typeof component === 'string' ? (
                                    <Typography variant={'body1'} color={color}>
                                        {component}
                                    </Typography>
                                ) : (
                                    component
                                )}
                            </MenuItem>
                        );
                    },
                )}
            </Menu>
        </Box>
    );
}
